import React from "react";
import { CHAT_MESSAGE_ROLE } from "../utils/triloChatConstants";

/**
 * TriloChatAvatar
 *
 * The round initials bubble beside a chat message. Anything that is not the
 * user (assistant replies, error notices, the typing indicator) is MW.
 *
 * Props:
 * - role: One of CHAT_MESSAGE_ROLE
 */
const TriloChatAvatar = ({ role }) => {
  const isUser = role === CHAT_MESSAGE_ROLE.user;
  const variant = isUser ? CHAT_MESSAGE_ROLE.user : CHAT_MESSAGE_ROLE.assistant;

  return (
    <div className={`trilochat__avatar trilochat__avatar--${variant}`}>
      {isUser ? "You" : "MW"}
    </div>
  );
};

export default TriloChatAvatar;
